import React from 'react';
import {createBrowserRouter, Navigate, RouterProvider, useParams} from 'react-router-dom';
import './App.css';
import StartPage from "./Routes/StartPage";
import JobsPage from "./Routes/JobsPage";
import Root from "./Routes/Root";
import GroupsPage from "./Routes/GroupsPage";
import GroupDetailPage from "./Routes/GroupDetailPage";
import JobDetailPage from "./Routes/JobDetailPage";
import AreaDetailPage from "./Routes/AreaDetailPage";
import SearchListPage from "./Routes/SearchListPage";
import SkillsPage from "./Routes/SkillsPage";
import TraitsPage from "./Routes/TraitsPage";
import ErrorPage from "./Routes/ErrorPage";
import RegionsPage from "./Routes/RegionsPage";
import RegionDetailPage from "./Routes/RegionDetailPage";
import CompaniesPage from "./Routes/CompaniesPage";
import ContactPage from "./Routes/ContactPage";
import AboutPage from "./Routes/AboutPage";

const GroupRedirect = () => {
  const { type, slug } = useParams();
  const redirectPath = `/yrkeskategorier${type ? `/${type}` : ''}${slug ? `/${slug}` : ''}`;
  return <Navigate to={redirectPath} replace />;
};

const SearchRedirect = () => {
  const { type } = useParams();

  if (type === 'yrkesgrupper') {
    return <Navigate to="/sok/yrkeskategorier" replace />;
  }

  return <SearchListPage />;
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: <StartPage /> },

      { path: '/yrken', element: <JobsPage /> },
      { path: '/yrken/:type/:slug?', element: <JobDetailPage /> },

      { path: '/yrkeskategorier', element: <GroupsPage /> },
      { path: '/yrkeskategorier/:type/:slug?', element: <GroupDetailPage /> },
      // Redirect old urls to new ones
      { path: '/yrkesgrupper', element: <Navigate to="/yrkeskategorier" replace /> },
      { path: '/yrkesgrupper/:type/:slug?', element: <GroupRedirect /> },

      { path: '/yrkesomraden/:type/:slug?', element: <AreaDetailPage /> },

      { path: '/kompetenser', element: <SkillsPage /> },
      { path: '/egenskaper', element: <TraitsPage /> },
      { path: '/arbetsgivare', element: <CompaniesPage /> },

      { path: '/regioner', element: <RegionsPage /> },
      { path: '/regioner/:code/:slug?', element: <RegionDetailPage /> },

      { path: '/sok/:type?', element: <SearchRedirect /> },

      { path: '/kontakt', element: <ContactPage /> },
      { path: '/om-tjansten', element: <AboutPage /> },
    ],
  },
], {
  future: {
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
    v7_skipActionErrorRevalidation: true,
  }
});

function App() {
  return (
    <RouterProvider router={router} future={{v7_startTransition: true} } />
  );
}

export default App;
